import { Link } from 'react-router-dom';

const Terms = () => {
    return (
        <div className="min-h-screen bg-dark text-gray-100 p-8 font-sans">
            <div className="max-w-4xl mx-auto space-y-8">
                <div className="flex justify-between items-center mb-12">
                    <Link to="/" className="text-xl font-bold text-primary hover:text-primary/80 transition-colors">
                        &larr; Back to App
                    </Link>
                    <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-orange-400">
                        Terms of Service
                    </h1>
                </div>

                <div className="bg-slate/10 border border-slate/20 shadow-2xl rounded-[2.5rem] overflow-hidden">
                    <div className="p-10 prose prose-invert max-w-none">
                        <section className="space-y-4 mb-8">
                            <h2 className="text-2xl font-black uppercase tracking-tighter text-white">1. Agreement to Terms</h2>
                            <p className="text-gray-400">By accessing or using DIYCarMech, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, then you may not access the service.</p>
                        </section>

                        <section className="space-y-4 mb-8 bg-primary/5 p-6 rounded-2xl border border-primary/20">
                            <h2 className="text-2xl font-black uppercase tracking-tighter text-primary flex items-center gap-2">
                                ⚠️ AI Diagnostic Disclaimer
                            </h2>
                            <p className="text-gray-300 font-bold">
                                DIYCarMech uses Artificial Intelligence to provide automotive diagnostic suggestions. These are suggestions ONLY and not professional advice.
                            </p>
                            <p className="text-gray-400">Always verify diagnostics with a certified master technician before performing repairs. We are not liable for any damage to your vehicle, personal injury, or property damage resulting from the use of this application.</p>
                        </section>

                        <section className="space-y-4 mb-8">
                            <h2 className="text-2xl font-black uppercase tracking-tighter text-white">3. User Accounts</h2>
                            <p className="text-gray-400">When you create an account with us (via Google Sign-In), you must provide information that is accurate and current. You are responsible for safeguarding the password that you use to access the service.</p>
                        </section>

                        <section className="space-y-4 mb-8">
                            <h2 className="text-2xl font-black uppercase tracking-tighter text-white">4. Intellectual Property</h2>
                            <p className="text-gray-400">The service and its original content, features, and functionality are and will remain the exclusive property of DIYCarMech and its licensors.</p>
                        </section>

                        <section className="space-y-4 mb-8">
                            <h2 className="text-2xl font-black uppercase tracking-tighter text-white">5. Links To Other Web Sites</h2>
                            <p className="text-gray-400">Our service contains affiliate links to third-party web sites (Amazon, eBay) that are not owned or controlled by DIYCarMech. We have no control over, and assume no responsibility for, the content or practices of any third-party web sites.</p>
                        </section>

                        <section className="space-y-4 mb-8">
                            <h2 className="text-2xl font-black uppercase tracking-tighter text-white">6. Termination</h2>
                            <p className="text-gray-400">We may terminate or suspend access to our service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
                        </section>

                        <p className="text-sm text-gray-500 mt-12 pt-8 border-t border-white/5">Last Updated: January 2026</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Terms;
